import "./SubHeader.scss";
import {Grid, Toolbar} from '@mui/material';
import FilterDropdown from "../Components/Filters/FilterDropdown";
import AwardListMenu from "../Components/AwardListMenu";
import SortMenu from "../Components/SortMenu";
import ViewMenuWithButton from "../Components/Menu/ViewMenuWithButton";
import makeStyles from '@mui/styles/makeStyles';
import BackLink from '../Components/BackLink';
import EntryListSearchBox from '../Components/Filters/EntryListSearchBox';

const useStyles = makeStyles((theme) => ({
    subHeaderRoot: {
        minHeight: "unset",
        position: 'relative',
        zIndex: 1,
        backgroundColor: theme.palette.secondary.main,
        width: "100%",
        alignItems: "stretch",

        [theme.breakpoints.up('sm')]: {
            padding: `0 ${theme.spacing(4)}`,
        },
        [theme.breakpoints.up('md')]: {
            position: 'sticky',
            top: 0,
            zIndex: 5,
        },
    },
    backWrap: {
        [theme.breakpoints.down('sm')]: {
           display: "none",
        },
        flexShrink: 1, flexGrow: 0,
    },
}));

export default function SubHeader ({ 
    currentAward, entries, 
    currentFixedCategories = [], activeFilters = {}, onFilterChange, additionalFilterTags = null,
    searchQueryText, onSearchChange, onSearchSubmit,
    backUrl = null, showMyListInMenu = false,
}) {
    const classes = useStyles();
    const hasPublishedDate = entries?.some(item => Boolean(item.data.publishedDate));
    const showRuntimeOptions = Boolean(currentAward?.hasRuntime);

    return (
        <>
            <Toolbar className={classes.subHeaderRoot}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    {backUrl ? (
                        <Grid item className={classes.backWrap}>
                            <BackLink to={backUrl} className="SubHeader__backlink" />
                        </Grid>
                    ):""}
                    <Grid item xs={true} className="SubHeader__awardlistmenuwrap">
                        <AwardListMenu currentAward={currentAward} currentFixedCategories={currentFixedCategories} showMyList={showMyListInMenu} />
                    </Grid>
                    <Grid item xs={12} md={true}>
                        <div className="SubHeader__menulayout">
                            <EntryListSearchBox 
                                className="SubHeader__searchbox" 
                                searchQuery={searchQueryText} 
                                onInput={onSearchChange} 
                                onSubmit={onSearchSubmit}
                            />
                            <div className="SubHeader__menus">
                                <SortMenu showDataAdded={hasPublishedDate} showRuntimeOptions={showRuntimeOptions} />
                                {currentAward && (
                                    <FilterDropdown
                                        award={currentAward} 
                                        entries={entries} 
                                        activeFilters={activeFilters} 
                                        displayCategories={!Boolean(activeFilters.fixedCategories)}
                                        onFilterChange={onFilterChange}
                                        additionalTags={additionalFilterTags}
                                    />
                                )}
                                <ViewMenuWithButton excludeGridView={currentAward && currentAward.hasCategoryPage && currentAward.judgingMediaType !== "game"} />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Toolbar>
        </>
    );
}